import { MapfreLoadingComponent } from '../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { HeaderComponent } from '../../../modules/mapfre-design-library/src/lib/_components/global-components/header/header.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Router , RouterModule } from '@angular/router';
import { Component } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, HeaderComponent, MapfreLoadingComponent],
  selector: 'app-loading-screen',
  templateUrl: './loading-screen.component.html',
})
export class LoadingScreenComponent {
  constructor(public router: Router) {}
}
